<input type="file"
       multiple
       hidden
       (change)="onFileInputChanged($event)"
       (click)="fileInput.value = null"
       [accept]="acceptTypes"
       #fileInput>
<div *ngIf="!readonly"
     class="file-input"
     [ngClass]="{ 'drag-over': isDragOver }"
     (click)="fileInput.click()"
     (dragover)="dragOver($event)"
     (dragleave)="isDragOver = false"
     (drop)="drop($event)">
    <div class="border-layer"></div>
    <span style="display: flex; flex-direction: column; gap: 8px">
        <div>
            Drag and drop files or click to upload
            <mat-icon>upload</mat-icon>
        </div>
        <div style="margin: auto">
            Maximum file size is {{ maxSize }}
        </div>
    </span>
</div>

<mat-list dense>

    <ng-container *ngIf="invalidFiles.length">
        <div mat-subheader>Invalid documents</div>

        <mat-list-item disableRipple
                       class="invalid-file"
                       *ngFor="let file of invalidFiles; let i = index">

            <mat-icon mat-list-icon>
                warning
            </mat-icon>

            <span matLine>{{ file.name }}</span>
            <span matLine>The format of this file is not allowed</span>
            <div class="actions">
                <button cll-icon-button
                        type="button"
                        (click)="clearInvalidFile(i)">
                    <cll-icon>clear</cll-icon>
                </button>
            </div>
        </mat-list-item>
    </ng-container>

    <ng-container *ngIf="pendingFiles.length">
        <div mat-subheader>{{ pendingSubheader }}</div>

        <mat-list-item disableRipple
                       class="uploading-file"
                       *ngFor="let file of pendingFiles; let i = index">
            <span matLine>{{ file.name }}</span>
            <button cll-icon-button
                    *ngIf="allowRemovePending && file.status === 'pending'"
                    (click)="removePending.emit({ file: file, index: i })"
                    type="button">
                <cll-icon>close</cll-icon>
            </button>
            <mat-icon *ngIf="file.status === 'pending'">schedule</mat-icon>
            <mat-spinner *ngIf="file.status === 'uploading'" diameter="24" />
            <mat-icon *ngIf="file.status === 'done'" class="icon-success">check_circle</mat-icon>
        </mat-list-item>
    </ng-container>

    <ng-container *ngIf="value && value.length">
        <div mat-subheader>{{ existingSubheader }}</div>
        <mat-list-item disableRipple
                       *ngFor="let file of value; let i = index"
                       class="existing-file">

            <mat-icon mat-list-icon
                      *ngIf="!file.url_128; else thumbnail">
                file_present
            </mat-icon>

            <ng-template #thumbnail>

                <img mat-list-avatar
                     class="thumbnail"
                     [src]="file.url_128"
                     cdkOverlayOrigin
                     (mouseover)="openOverlay(thumbnailEl, popover)"
                     (mouseout)="closeOverlay()"
                     #trigger="cdkOverlayOrigin"
                     #thumbnailEl/>

                <ng-template cdkConnectedOverlay
                             #popover>
                    <img class="file-input-popover-img"
                         [src]="file.url_512 || file.url_256 || file.url_128"/>
                </ng-template>

            </ng-template>

            <p matLine>
                <a [href]="file.url"
                   download
                   target="_blank"
                   cllTooltip="Click to download">
                    {{ file.name }}
                </a>
            </p>
            <p matLine>
                Uploaded: {{ file.created_at | appTimestamp }}

                <span class="hint"
                      *ngIf="file.updated_at !== file.created_at">
                    (Updated: {{ file.updated_at | appTimestamp }})
                </span>
            </p>

            <div *ngIf="!readonly" class="actions">
                <button cll-icon-button
                        type="button"
                        (click)="editFile.emit(file)">
                    <cll-icon>edit</cll-icon>
                </button>

                <button cll-icon-button
                        colour="warn"
                        type="button"
                        (click)="deleteFile.emit(file)">
                    <cll-icon>delete</cll-icon>
                </button>
            </div>
        </mat-list-item>
    </ng-container>
</mat-list>
